module.exports = __webpack_public_path__ + "static/media/ic_covid_waiting_period_myway.8c63266e.svg";